import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

//
import app    from '@/App.vue'
import r_link from '@/components/RouterLink.vue'
import d_link   from '@/components/Link.vue'

//
Vue.component('app', app)
Vue.component('r-link', r_link)
Vue.component('d-link', d_link)

//
import main                 from '@/components/Main.vue'
import liver                from '@/components/Liver.vue'
import settings             from '@/components/Settings.vue'
import youtube_names        from '@/components/ChannelName.vue'
import notification_setting from '@/components/NotificationSetting.vue'

export default new Router({
  mode: 'history',
  routes: [
    { path: '/',          name: 'main',     component: main,      meta: {name: 'メイン',   color: '#2665AC'}},
    { path: '/livers',    name: 'liver',    component: liver,     meta: {name: 'メンバー',  color: '#6CBFEB'}},
    { path: '/youtube/names',    name: 'youtube_names',    component: youtube_names,     meta: {name: 'YouTubeチャンネル名一覧',  color: '#314B6E'}},
    { path: '/settings',  name: 'settings', component: settings,  meta: {name: '設定',     color: '#314B6E'}},
    { path: '/settings/notification_setting', name: 'notification_setting', component: notification_setting}
  ],
})
